

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface PatientDiagnosisParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface PatientDiagnosis {

  id?: string;
  diagnosisId: string;
  regId: string;
  visitId: number;
  treatmentGiven: string;
  risk: string;
  tenantId: string;
  branchId: string;
  visitedDate?:Date;
  admissionId?:number;
  physicianId:string;
  justVisit :string;

 docIdForQC?:string;
 NameForQC?:string;
 onSet?:string;
  
 //Log
 createdDate?:Date;
 updatedDate?:Date;
 createdBy?:number;
 updatedBy?:number;
 createdIP?:string;
 updatedIP?:string;
  parameters?: PatientDiagnosisParameter[];
  links?: any;

  updatedDiagnosisId:number;
  performingNurse?:string;
  performingDoctor?:string;
  diagnosisType?:any;
  diagnosisTypeId?:number;
}

export abstract class PatientDiagnosisData {
  abstract list(url: string): Observable<PatientDiagnosis[]>;
  abstract users(url: string): Observable<any[]>;
  abstract create(url: string,data: PatientDiagnosis): Observable<any>;
  abstract search(url: string,data: any): Observable<any>;
  abstract update(url: string,data: PatientDiagnosis): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
